
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      let self = this
      this.canvasForms = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(20, 20)`)
      .attr('cursor', 'default')
      .attr('font-family', 'roboto')

      this.canvasForms
      .append('image')
      .attr('transform', `translate(170, -15)`)
      .attr('xlink:href', this.HOST + `/SystemCompletion/SystemBoundary/${this.revision}/svg/${this.rawData.SYS}.svg`)
      .attr('x', 0).attr('y', 0).attr('opacity', .9).attr('width', 600)
      .on('error', function() {
        d3.select(this).attr('xlink:href', self.HOST +`/SystemCompletion/SystemBoundary/${self.revision}/svg/NA.svg`)
      })

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 0)`).attr('font-size', 9).attr('fill', '#757575')
      .text('System No.')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 15)`).attr('font-size', 14).attr('fill', '#333')
      .text(this.rawData.SYS)


      this.pcc.forEach(d => {

        let idList = {
          'P': { x: 150, value: this.rawData.PCC_P },
          'F': { x: 150, value: this.rawData.PCC_F },
          'A': { x: 250, value: this.rawData.PCC_A }
        }
        let currentID = idList[d.id]
      
        if (currentID) {
        
          this.canvasForms
            .append('text')
            .attr('transform', `translate(${currentID.x}, 0)`)
            .attr('font-size', 10)
            .attr('fill', '#757575')
            .text(`${d.name}`)
        
          this.canvasForms
            .append('text')
            .attr('transform', `translate(${currentID.x}, 15)`)
            .attr('font-size', 13)
            .attr('fill', '#757575')
            .text(currentID.value)
        }
      })

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 40)`).attr('font-size', 9).attr('fill', '#757575')
      .text('System Description')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 55)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.SYS_DESC)


      

      this.draw_ITRs()


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }

    },
  }
}